
































































import { Component } from 'vue-property-decorator';

import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/SucursalVirtual/VerFacturacion/FiltrosBusqueda.vue';
import showRefs from '@/pantallas/SucursalVirtual/VerFacturacion/showRefs.vue';
import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import { actionsEvent } from '@/setup';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import {
  checkboxColumnDef,
  makeAccionesColumnDef_DEPRECATED,
  creadoPorColumnDefs,
  modificadoPorColumnDefs,
  fechaCreacionColumnDefs,
  fechaModificacionColumnDefs,
} from '@/reusable/Grid/aggridColumnDefUtils';
import { LoadingService } from '@/services/loadingService';
import HandleErrors from '@/config/handleErrors'; //
import { ComponenteBase, Accion } from '@/views/base/ComponenteBase';
import moment from 'moment';
import Analitica from '@/pantallas/SucursalVirtual/analitica_uso';

import {
  dowloadDocs,
  fetchDte,
  Factura,
  MsResponseData,
  parseFactura,
} from '@/pantallas/SucursalVirtual/VerFacturacion/fetchDte';

import {
  TipoDte,
  fetchTipoDte,
} from '@/pantallas/SucursalVirtual/VerFacturacion/fetchTipoDte';

import {
  TipoEstado,
  fetchTipoEstados,
} from '@/pantallas/SucursalVirtual/VerFacturacion/fetchEstados';

import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import WidgetUser from '@/pantallas/SucursalVirtual/WidgetUser.vue';
import { requestMS } from '@/pantallas/SucursalVirtual/VerFacturacion/requestMS';
import {
  ConfigEmpresas,
  fetchMS,
} from '@/pantallas/SucursalVirtual/NuevaSolicitud/fetchConfigInicial';

@Component({
  components: {
    MantenedorGridSinCodigo,
    FiltrosBusqueda,
    WidgetUser,
    showRefs,
  },
})
export default class VerFacturaciones extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.VerFacturacion;
  readonly loadingService = new LoadingService();

  analytic = new Analitica(100, window.location.href);

  categoriaUsuario: string = '';
  listaEmpresas: ConfigEmpresas[] = [];

  lstTipoDTE: TipoDte[] = [];
  lstEstados: TipoEstado[] = [];
  columnApi: any = null;
  MsResponseData: MsResponseData = null;
  facturaciones: Factura[] = null;

  requestsStart: number = 0;

  gridApi: GridApi = null;
  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Nº Documento',
        field: 'folio',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Tipo Documento',
        field: 'tipoDte',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Monto sin IVA',
        field: 'montoNeto',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Valor IVA',
        field: 'montoIva',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Monto Total',
        field: 'montoTotal',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Fecha Emisión',
        field: 'fechaEmision',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Fecha Vencimiento',
        field: 'fechaVencimiento',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Estado SII',
        field: 'estadoSii',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Estado Pago',
        field: 'estadoPago',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Referencias',
        cellRendererFramework: showRefs,
        field: 'referencias_link',
      },
      {
        headerName: 'urlDetallePdf',
        headerClass: 'hide hideuri',
        field: 'urlDetallePdf',
        cellStyle: { display: 'none', width: '0px!important' },
        hide: true,
      },
      {
        headerName: 'uri',
        headerClass: 'hide hideuri',
        field: 'uriPdf',
        cellStyle: { display: 'none', width: '0px!important' },
        hide: true,
      },
      {
        headerName: 'referencias',
        headerClass: 'hide hideuri',
        field: 'referencias',
        cellStyle: { display: 'none', width: '0px!important' },
        hide: true,
      },
    ].map(x => ({
      width: 150,
      ...x,
    })),
    pagination: true,
    paginationPageSize: 25,
    onGridReady: this.handleGridReady,
    onModelUpdated: this.onModelUpdated,
    processCellForClipboard: ({ value }) => {
      return value instanceof moment
        ? this.formatFecha(value as moment.Moment)
        : value;
    },
  };

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.getEstados();
    this.getTipoDTE();
    this.buscarFactura(
      '',
      '',
      '',
      '',
      '',
      '10',
      localStorage.getItem('clienteDefecto')
    );
    //this.facturaInicial();
  }

  async destroyed() {
    let salida = await this.analytic.salida(this.analytic.id_analitica);
  }

  exportar(tipo: string) {
    let header =
      'Nro Documento;Tipo Documento;Monto sin IVA;Valor IVA; Monto Total; Fecha Emisión; Fecha Vencimiento;Estado SII; Estado Pago; Referencias; Url Documento; Url Detalle;\r\n';
    let body = '';
    this.facturaciones.forEach(v => {
      body += v.folio + ';';
      body += v.tipoDte + ';';
      body += v.montoNeto + ';';
      body += v.montoIva + ';';
      body += v.montoTotal + ';';
      body += v.fechaEmision + ';';
      body += v.fechaVencimiento + ';';
      body += v.estadoSii + ';';
      body += v.estadoPago + ';';
      body += JSON.parse(v.referencias).join(' ') + ';';
      body += v.uriPdf + ';';
      body += v.urlDetallePdf + ';\r\n';
    });
    let csvContent = 'data:text/csv;charset=utf-8,' + header + body;
    let encodedUri = encodeURI(csvContent);
    let link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'documentos.csv');
    link.classList.add('urldownload');
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  showLoading() {
    this.requestsStart += 1;
    if (this.requestsStart == 1) {
      this.loadingService.showLoading();
    }
  }
  hideLoading() {
    this.requestsStart -= 1;
    if (this.requestsStart == 0) {
      this.loadingService.hideLoading();
    }
  }

  async facturaInicial() {
    //this.facturacionesInicio =
    //  (await this.fetchDte(null, null, null, null, null, null)) || [];
    //this.gridApi.setRowData(this.facturacionesInicio);
  }

  fetchDte(
    folio: string,
    tipoDTE: string,
    fechaInicioEmision: string,
    fechaFinEmision: string,
    estado: string,
    cantidadRegistros: string,
    clienteDefecto: string
  ) {
    this.showLoading();
    return fetchDte(
      folio,
      tipoDTE,
      fechaInicioEmision,
      fechaFinEmision,
      estado,
      cantidadRegistros,
      clienteDefecto
    )
      .catch(error => {
        this.$snotify.error(
          this.$t('mensajes.mensajesError.consulta', {
            entidad: 'las facturaciones',
          })
        );
        return;
      })
      .finally(() => this.hideLoading());
  }

  autoSizeAll(skipHeader: boolean) {
    this.columnApi.autoSizeColumns(
      this.columnApi.getAllDisplayedColumns().map((x: any) => x.colId)
    );
  }

  async buscarFactura(
    folio: string,
    tipoDTE: string,
    fechaInicioEmision: string,
    fechaFinEmision: string,
    estado: string,
    cantidadRegistros: string,
    clienteDefecto: string
  ) {
    this.MsResponseData =
      (await this.fetchDte(
        folio,
        tipoDTE,
        fechaInicioEmision,
        fechaFinEmision,
        estado,
        cantidadRegistros,
        clienteDefecto
      )) || null;
    if (this.MsResponseData !== null) {
      if (this.MsResponseData.CODIGO_RESPUESTA == '1') {
        if (this.MsResponseData.data.length > 0) {
          this.facturaciones = this.MsResponseData.data.map(parseFactura);
          this.gridApi.setRowData(this.facturaciones);
          this.gridApi.setDomLayout('autoHeight');
          this.autoSizeAll(true);
        } else {
          this.facturaciones = null;
          this.$snotify.error('No se han encontrado registros.', {
            timeout: 3000,
          });
        }
      } else {
        this.facturaciones = null;
        this.$snotify.error(this.MsResponseData.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      }
    }
  }

  filtroFacturacion(filtros: any) {
    let documento = '';
    if (filtros.tipoDTE.value == '2') {
      documento = '61';
    } else if (filtros.tipoDTE.value == '1') {
      documento = '33';
    } else {
      documento = filtros.tipoDTE.value;
    }
    let cr = '';
    if (filtros.cantidadRegistros.value == '') {
      cr = '10';
    } else {
      cr = filtros.cantidadRegistros.value;
    }
    'Nota Crédito';

    let clienteDefecto = '';
    if (this.categoriaUsuario == 'Interno') {
      clienteDefecto = filtros.empresa.value;
    } else {
      clienteDefecto = localStorage.getItem('clienteDefecto');
    }

    let fechaInicioEmision = moment(filtros.fechaDesde.value).format('YYYYMM');
    let fechaFinEmision = moment(filtros.fechaHasta.value).format('YYYYMM');

    this.gridApi.setRowData([]);
    this.buscarFactura(
      filtros.folio.value,
      documento,
      fechaInicioEmision,
      fechaFinEmision,
      filtros.estado.value,
      cr,
      clienteDefecto
    );
  }

  async getTipoDTE() {
    this.lstTipoDTE = (await this.cargarTipoDTE()) || [];
  }

  cargarTipoDTE() {
    this.showLoading();
    return fetchTipoDte()
      .catch(error => {
        if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los tipos de Giros',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => this.hideLoading());
  }

  async getEstados() {
    this.lstEstados = (await this.cargarEstados()) || [];
    this.lstEstados.unshift({ id: 0, nombre: 'Todas' });
  }

  cargarEstados() {
    this.showLoading();
    return fetchTipoEstados()
      .catch(error => {
        if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los tipos de Giros',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => this.hideLoading());
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  fechaQuickFilterGetter(params: GetQuickFilterTextParams) {
    return this.formatFecha(params.value);
  }

  fechaValueFormatter(params: ValueFormatterParams) {
    return this.formatFecha(params.value);
  }

  accionVerPdf: PermisoAccion = {
    accionCodigo: 89,
    visible: false,
  };
  accionVerDetalle: PermisoAccion = {
    accionCodigo: 4,
    visible: false,
  };
  accionDescargar: PermisoAccion = {
    accionCodigo: 10,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionVerPdf, this.accionDescargar];

  handleVerDetalleClick(params: ICellRendererParams) {
    if (params.data.urlDetallePdf == '') {
      this.$snotify.error('Documento sin detalle disponible', {
        timeout: 3000,
      });
    } else {
      window.open(params.data.urlDetallePdf, '_blank');
    }
  }
  handleDescargarClick(params: ICellRendererParams) {
    this.showLoading();
    let refs: string[] = [];
    if (params.data.referencias != '') {
      refs = JSON.parse(params.data.referencias);
    }
    dowloadDocs([params.data.uriPdf, params.data.urlDetallePdf].concat(refs))
      .then(response => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          let encodedUri = response.data.zipb64;
          let link = document.createElement('a');
          link.setAttribute('href', 'data:text/plain;base64,' + encodedUri);
          link.setAttribute('download', 'documentos.zip');
          link.classList.add('urldownload');
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          this.$snotify.error('Error: ' + response.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
        }
      })
      .catch(error => {
        if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar descargar los documentos',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => this.hideLoading());
  }

  constructor() {
    super();
    actionsEvent.onVerPdf(this.handleVerPdfClick);
    actionsEvent.onVerDetalle(this.handleVerDetalleClick);
    actionsEvent.onDescargar(this.handleDescargarClick);
    actionsEvent.onVerReferencia(this.handleVerReferenciaClick);
  }

  async handleVerPdfClick(params: ICellRendererParams) {
    window.open(params.data.uriPdf, '_blank');
  }

  async handleVerReferenciaClick(params: ICellRendererParams) {
    if (params.data.referencias == '') {
      this.$snotify.error('Este documento no contiene referencias', {
        timeout: 3000,
      });
      return false;
    }
    let arrayRefs = JSON.parse(params.data.referencias);
    arrayRefs.forEach((v: string) => {
      window.open(v, '_blank');
    });
  }

  generarPago(metodo: string) {
    this.loadingService.showLoading();
    let dataSeleccionada = this.gridApi.getSelectedNodes();
    let lista: any[] = [];
    let that = this;
    dataSeleccionada.forEach(function(v) {
      if (!['33)', '34)', '39)'].includes(v.data.tipoDte.split('(')[1])) {
        that.$snotify.error(
          'Debe seleccionar solo boletas o facturas para pagar.',
          {
            timeout: 3000,
          }
        );
        return false;
      }
      lista.push(v.data);
    });
    // console.log(lista);
    lista = lista.map(x => {
      return {
        folio: x.folio,
        monto: x.montoTotal,
        fechaVencimiento: x.fechaVencimiento.replaceAll('-', ''),
      };
    });
    // console.log(lista);
    if (lista.length == 0) {
      this.$snotify.error('Debe seleccionar un documento', {
        timeout: 3000,
      });
      return false;
    }

    let body: any = {};
    body.lista = lista;
    body.cliente = JSON.parse(localStorage.getItem('user')).clienteDefecto;
    body.user_id = JSON.parse(localStorage.getItem('user')).id;
    const ms = metodo;
    requestMS(body, 'iniciaPago', ms)
      .then((response: any) => {
        console.log(response);
        if (response.data.CODIGO_RESPUESTA == '1') {
          let url = '';
          if (metodo == 'servipag') {
            url = process.env.VUE_APP_SERVICIO_MS + response.data.url;
            window.open(url, '_blank');
          }
          if (metodo == 'transbank') {
            url = response.data.url;
            let token = response.data.token;
            let form = document.createElement('form');
            form.action = url;
            form.method = 'POST';
            let input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'token_ws';
            input.value = token;
            form.appendChild(input);
            document.body.appendChild(form);
            form.submit();
          }
          console.log(url);
        } else {
          that.$snotify.error(response.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
        }
      })
      .catch((error: any) => {
        that.$snotify.error('Ocurrió un error. Intente nuevamente.', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  async getCategoriaUsuario() {
    let configOK = JSON.parse(window.localStorage.user).configOKSucursal;
    if (!configOK) {
      this.$snotify.warning('Usuario sin Sucursal Virtual activa en CRM', {
        timeout: 10000,
      });
    }

    let categoria = JSON.parse(window.localStorage.user).categoria;
    if (categoria !== undefined) {
      console.log(
        'retorno categoria desde localStorage categoria=' + categoria
      );
      this.categoriaUsuario = categoria;
    } else {
      let r: any = [];
      r =
        (await this.fetchCategoriaUsuario(
          JSON.parse(window.localStorage.user).email
        )) || [];
      r = r['data'];
      if (r['CODIGO_RESPUESTA'] !== '1') {
        this.$snotify.error(r['MENSAJE_RESPUESTA'], { timeout: 3000 });
        this.categoriaUsuario = 'Externo';
        console.log(this.categoriaUsuario);
      } else {
        categoria = r['categoria'];
        console.log('retorno categoria desde MS categoria=' + categoria);
        this.categoriaUsuario = categoria;
        if (this.categoriaUsuario == 'Interno') {
          this.getEmpresas();
        }
        if (!r['config_ok_sucursal']) {
          this.$snotify.warning('Usuario sin Sucursal Virtual activa en CRM', {
            timeout: 10000,
          });
        }
      }
    }
  }
  fetchCategoriaUsuario(mail: string) {
    return fetchMS({ email: mail }, 'track/get_categoria_sc').catch(error => {
      if (error.message == 'Network Error') {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener las categorias',
          { timeout: 3000 }
        );
      } else if (error.response.status != 404) {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener las categorias',
          { timeout: 3000 }
        );
      }
    });
  }
  async getEmpresas() {
    console.log('getEmpresas');
    this.loadingService.showLoading(undefined, 'getEmpresas');
    let r: any = [];
    r = (await this.cargarEmpresas()) || [];
    r = r['data'];
    if (r['CODIGO_RESPUESTA'] == '1') {
      this.listaEmpresas = r['data'];
      this.loadingService.hideLoading('getEmpresas');
    } else {
      this.$snotify.error(r['MENSAJE_RESPUESTA'], { timeout: 3000 });
      this.loadingService.hideLoading('getEmpresas');
    }
  }
  cargarEmpresas() {
    return fetchMS({}, 'track/get_ListadoCuentas_sc').catch(error => {
      if (error.message == 'Network Error') {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener el listado de cuentas',
          { timeout: 3000 }
        );
      } else if (error.response.status != 404) {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener el listado de cuentas',
          { timeout: 3000 }
        );
      }
    });
  }

  async mounted() {
    let entrada = await this.analytic.entrada();
    this.getCategoriaUsuario();
    console.log(this.categoriaUsuario);
    if (this.categoriaUsuario == 'Interno') {
      this.getEmpresas();
    }
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
    //@ts-ignore
    if (this.gridApi.rowModel.rowsToDisplay.length == 0) {
      this.gridApi.showNoRowsOverlay();
    } else {
      this.gridApi.hideOverlay();
    }
  }
}
